export enum reducersNames {
  MONITORING = 'monitoring',
  MAP = 'map',
  MAP_V2 = 'map_v2',
  AUTH = 'auth',
  SERVICE = 'service',
  COMMON = 'common',
  REPORTS = 'reports',
  SETTINGS = 'settings',
  FAVORITES = 'favorites',
  INTERCEPTIONS = 'interceptions',
}

export enum asyncActionsNames {
  GET_FILTERS = 'getFilters',
  GET_LANG_CORPUS_TREE = 'getCorpusTree',
  SEARCH_POSTS = 'searchPosts',
  ADD_FEATURE = 'addFeature',
  EDIT_FEATURE = 'editFeature',
  DELETE_FEATURE = 'deleteFeature',
  GET_GEOSPOOF = 'getGeospoof',
  GET_LAYER_CHILDREN = 'getLayerChildren',
  ADD_LAYER = 'addLayer',
  EDIT_LAYER = 'editLayer',
  DELETE_LAYER = 'deleteLayer',
  DELETE_MAP_ENTITIES = 'deleteMapEntities',
  LOGIN = 'login',
  GET_PRIVILEGES = 'getPrivileges',
  DELETE_FEATURE_MEDIA = 'deleteFeatureMedia',
  ADD_FEATURE_MEDIA = 'addFeatureMedia',
  ADD_BATCH_FEATURES = 'addBatchFeatures',
  GET_SEARCH_HISTORY = 'getSearchHistory',
  GET_SEARCH_INFO = 'getSearchInfo',
  GET_PICTURES_UPLOAD_ID = 'getRequestIdUserPictures',
  GET_ENTITY_PICTURES = 'getLinksUserPictures',
  GET_USER_LOCATION = 'getUserLocation',
  DOWNLOAD_FEATURES = 'downloadFeatures',
  GET_LOADED_USER_LOCATION = 'getLoadedUserLocation',
  ADD_REPORT = 'addReport',
  ADD_CLIENT = 'addСlient',
  GET_ATTRIBUTES = 'getAttributes',
  GET_USER_TABLE = 'getUserTable',
  GET_REPORTS_TABLE = 'getReportsTable',
  GET_OPERATIONAL_RANGES = 'getOperationalRanges',
  GET_OPERATIONAL_OBJECTS = 'getOperationalObjects',
  GET_IMAGERY = 'getImagery',
  GET_IMAGERY_PREVIEW = 'getImageryPreview',
  UPDATE_IMAGERY = 'updateImagery',
  GET_PARSERS = 'getParsers',
  ADD_BOOKMARK = 'addBookmark',
  DELETE_BOOKMARK = 'deleteBookmark',
  GET_BOOKMARK_IDS = 'getBookmarkIds',
  GET_INITIAL_MAP_ENTITIES = 'getInitialMapEntities',
  GET_FILTERED_MAP_ENTITIES = 'getFilteredMapEntities',
  GET_SHARED_ENTITY = 'getSharedEntity',
  GET_INSCRIBED_MAP_ENTITIES = 'getInscribedMapEntities',
  OPEN_MAP_FOLDER_ENTITY = 'openMapFolderEntity',
  SELECT_MAP_FOLDER_ENTITY = 'selectMapFolderEntity',
  GET_ALL_MAP_ENTITIES = 'getAllMapEntities',
  CREATE_MAP_ENTITY = 'createEntity',
  CREATE_QUICK_MAP_ENTITY = 'createQuickEntity',
  IMPORT_MAP_ENTITIES = 'importEntities',
  UPDATE_MAP_ENTITY = 'updateEntity',
  UPDATE_MAP_ENTITIES_BULK = 'updateEntitiesBulk',
  RELINK_MAP_ENTITY = 'relinkEntity',
  REGROUP_MAP_ENTITIES = 'regroupEntities',
  ADD_MEDIA_TO_MAP_ENTITY = 'addMediaToEntity',
  DELETE_ENTITY = 'deleteEntity',
  GET_SELF_USER = 'getSelfUser',
  GET_FIRES = 'getFires',
  GET_MAP_ENTITIES_HISTOGRAM = 'getMapEntitiesHistogram',
  GET_INTERCEPTIONS_LIST = 'getInterceptionsList',
  GET_INTERCEPTION_BY_ID = 'getInterceptionById',
  GET_INTERCEPTION_TRANSCRIPTS_BY_ID = 'getInterceptionTranscriptsById',
  UPDATE_INTERCEPTION_NETWORK_BY_ID = 'updateInterceptionNetworkById',
  UPDATE_INTERCEPTION_MEMBER_BY_ID = 'updateInterceptionMemberById',
  GET_INTERCEPTION_MEMBERS = 'getInterceptionMembers',
  GET_INTERCEPTION_NETWORKS = 'getInterceptionNetworks',
  GET_INTERCEPTION_DEPARTMENTS = 'getInterceptionDepartments',
  GET_INTERCEPTION_MEMBER_BY_ID = 'getInterceptionMemberByID',
  GET_INTERCEPTION_NETWORK_BY_ID = 'getInterceptionNetworkById',
}
